
const _ = require('lodash');

/**
 * Valida si es el valor es un string
 * @param {*} valor 
 * @returns 
 */
const isString = (valor) => {
  return _.isString(valor);
}

/**
 * 
 * @param {string} str string que se quiere truncar
 * @param {number} maxLen limite máximo de la cadea
 * @param {string} separator indica cuando se debe parar la cadena al alcanzar el maximo
 * @param {string} textoFinal texto adicional a agregar al texto port defecto "..."
 * @returns 
 */
const truncateString = (str, maxLen, separator = ' ', textoFinal = '...') => {
  if (str.length <= maxLen) return str;
  return str.substr(0, str.lastIndexOf(separator, maxLen)) + textoFinal;
}

/**
 * Valida si el email es válido
 * @param {*} email 
 * @returns 
 */
const isEmailValido = email => {
  return (email && email !== 'notiene@mundopacifico.cl' && email !== 'S/I') ? email : '';
}

/**
 * Replaza todas las ocurrencias en el string
 * @param {*} str string principal
 * @param {*} search strig que se quiere cambiar
 * @param {*} replacement valor por el cual se cambia
 * @returns 
 */
var replaceAll = (str, search, replacement) =>  {
  var newStr = ''
  if (_.isString(str)) {
    newStr = str.split(search).join(replacement)
  }
  return newStr
}

export const stringFunctionHelpers = {
  truncateString: truncateString,
  isEmailValido: isEmailValido,
  isString: isString,
  replaceAll: replaceAll
}